import { render, staticRenderFns } from "./ScrollThumb.vue?vue&type=template&id=3b191509&"
import script from "./ScrollThumb.vue?vue&type=script&lang=js&"
export * from "./ScrollThumb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports